import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, LabeledCheckbox, Button } from 'oxyrion-ui/lib';
import i18next from 'i18next';
import styled from 'styled-components';
import { rem } from 'polished';
import AlertPopup from '../../../Components/AlertPopup';
import { __ } from '../../../Utils';
import { connect, actions } from '../../../Store';
import API2 from '../../../API2';

const Row = styled.div`
  padding: ${rem(10)};
`;

class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      price: true,
      price_vat: true,
      price_wd: false,
      price_wd_vat: false,
      disableSave: false,
      ean: true,
      volume: true,
      inventory: true,
      subscribed: false,
      activeTab: 'tab3',
      appLang: 'SK',
    };
  }

  async componentDidMount() {
    try {
      const me = await API2.getB2BUserAction(this.props.user._id);
      const { b2b_settings: settings } = me;

      this.setState({
        subscribed: me.newsletter_subscribe && me.newsletter_subscribe.status,
        appLang: me.appLang,
        price: settings.products.price,
        price_vat: settings.products.price_vat,
        price_wd: settings.products.price_wd,
        price_wd_vat: settings.products.price_wd_vat,
        ean: settings.products.ean,
        volume: settings.products.volume,
        inventory: settings.products.inventory,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async changeSubscribeTo(newStatus) {
    try {
      await API2.putB2BContactNewsletterSubscriptionAction({
        body: {
          subscribed: newStatus,
        },
      });

      this.setState({
        subscribed: newStatus,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async changeAppLangTo(appLang) {
    try {
      i18next.changeLanguage(appLang);

      await API2.putB2BMeAppLangAction({
        body: {
          lang: appLang,
        },
      });

      this.setState({
        appLang,
      });

      window.location.reload(false);
    } catch (e) {
      console.log(e);
    }
  }

  async save() {
    const {
      price,
      price_vat,
      price_wd,
      price_wd_vat,
      ean,
      volume,
      inventory,
    } = this.state;

    try {
      const result = await API2.putB2BMeSettingsAction({
        body: {
          products: {
            price,
            price_vat,
            price_wd,
            price_wd_vat,
            ean,
            volume,
            inventory,
          },
        },
      });

      actions.setSettings(result.b2b_settings);

      this.setState({
        disableSave: true,
        success: true,
      });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const {
      price,
      price_vat,
      price_wd,
      price_wd_vat,
      success,
      disableSave,
      ean,
      volume,
      inventory,
      activeTab,
      subscribed,
      appLang,
    } = this.state;

    return (
      <React.Fragment>
        <AlertPopup
          display={success}
          success
          text={__('Nastavenia uložené')}
          onClose={() =>
            this.setState({
              success: false,
            })
          }
          onSubmit={() =>
            this.setState({
              success: false,
            })
          }
        />
        <Tabs
          activeTab={{
            id: activeTab,
          }}
          onChange={e => {
            this.setState({
              activeTab: e,
            });
            return true;
          }}
        >
          <Tabs.Tab id="tab1" title={__('Zobrazenie produktov')}>
            <Row>
              <LabeledCheckbox
                labelText={__('Ean')}
                checked={ean}
                onChange={() =>
                  this.setState({
                    ean: !ean,
                    disableSave: false,
                  })
                }
              />
            </Row>
            <Row>
              <LabeledCheckbox
                labelText={__('Objem')}
                checked={volume}
                onChange={() =>
                  this.setState({
                    volume: !volume,
                    disableSave: false,
                  })
                }
              />
            </Row>
            <Row>
              <LabeledCheckbox
                labelText={__('Zásoby')}
                checked={inventory}
                onChange={() =>
                  this.setState({
                    inventory: !inventory,
                    disableSave: false,
                  })
                }
              />
            </Row>
            {this.props.user.role !== 'b2b_user' && (
              <Row>
                <LabeledCheckbox
                  labelText={__('Nákupná cena bez DPH')}
                  checked={price}
                  onChange={() =>
                    this.setState({
                      price: !price,
                      disableSave: false,
                    })
                  }
                />
              </Row>
            )}
            {this.props.user.role !== 'b2b_user' && (
              <Row>
                <LabeledCheckbox
                  labelText={__('Nákupná cena s DPH')}
                  checked={price_vat}
                  onChange={() =>
                    this.setState({
                      price_vat: !price_vat,
                      disableSave: false,
                    })
                  }
                />
              </Row>
            )}

            <Row>
              <LabeledCheckbox
                labelText={__('Predajná cena bez DPH')}
                checked={price_wd}
                onChange={() =>
                  this.setState({
                    price_wd: !price_wd,
                    disableSave: false,
                  })
                }
              />
            </Row>

            <Row>
              <LabeledCheckbox
                labelText={__('Predajná cena s DPH')}
                checked={price_wd_vat}
                onChange={() =>
                  this.setState({
                    price_wd_vat: !price_wd_vat,
                    disableSave: false,
                  })
                }
              />
            </Row>
            <Row>
              <Button
                primary
                onClick={() => this.save()}
                disabled={disableSave}
              >
                {__('Uložiť')}
              </Button>
            </Row>
          </Tabs.Tab>
          <Tabs.Tab id="tab2" title={__('Newsletter')}>
            <Row>
              <LabeledCheckbox
                labelText={__('Chcem odoberať novinky')}
                checked={subscribed}
                onChange={() => this.changeSubscribeTo(!subscribed)}
              />
            </Row>
          </Tabs.Tab>
          <Tabs.Tab id="tab3" title={__('Jazyk aplikácie')}>
            {this.props.langs.map(l => (
              <Row>
                <LabeledCheckbox
                  labelText={__(l.lang_name)}
                  checked={appLang === l._id}
                  onChange={() => this.changeAppLangTo(l._id)}
                />
              </Row>
            ))}

            {/* <Row>
              <Button
                primary
                onClick={() => window.location.reload(false)}
                disabled={disableSave}
              >
                {__('Aplikovať')}
              </Button>
            </Row> */}
          </Tabs.Tab>
        </Tabs>
      </React.Fragment>
    );
  }
}

Settings.propTypes = {
  settings: PropTypes.shape({}),
};

Settings.defaultProps = {
  settings: null,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Settings);



// WEBPACK FOOTER //
// ./src/Containers/Settings/Portal/index.jsx